import React, { useMemo } from 'react';
import Streamline from '@/components/shared/streamline/Streamline';
import Double from '@/components/shared/streamline/children-layouts/Double';
import GameProviderCard from '@/components/shared/card/GameProviderCard';

const GameProvidersDoubleStreamline = ({
  slug,
  gameProviders,
  onClick,
}: {
  slug: string;
  gameProviders: string[];
  onClick: (providerSlug: string) => void;
}) => {
  const providerClick = (provider: string) => {
    onClick(provider);
  };

  const children = useMemo(() => {
    const indexes = Math.ceil(gameProviders.length / 2);
    return Array.from(Array(indexes).keys()).map(startIndex => {
      const index = startIndex * 2;
      const firstProvider = gameProviders[index];
      const secondProvider = gameProviders[index + 1];
      return (
        <Double key={`${slug}-${firstProvider}-${secondProvider}`}>
          {firstProvider && (
            <GameProviderCard slug={firstProvider} onClick={() => providerClick(firstProvider)} />
          )}
          {secondProvider && (
            <GameProviderCard slug={secondProvider} onClick={() => providerClick(secondProvider)} />
          )}
        </Double>
      );
    });
  }, [gameProviders]);

  return <Streamline loop children={children} />;
};

export default GameProvidersDoubleStreamline;
